<template>
  <div
    class="mt-2 sm:my-6"
    @dragover="setActive"
    @dragleave="cancelActive"
    @drop="fileAdded"
  >
    <label for="filePicker" class="flex justify-center px-6 pt-5 pb-6 border-2 border-dashed rounded-md cursor-pointer m-2"
    :class="[ isActive ? 'bg-cool-gray-200 border-cool-gray-100' : 'border-gray-300' ]">
      <div class="text-center">
        <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48">
          <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <input
          id="filePicker"
          class="hidden"
          type="file"
          name="filePicker"
          :accept="accept"
          :multiple="allowMultiple"
          @change="fileAdded"
        >
        <slot name="label" class="mt-1 text-sm text-gray-600">
          <span type="button" class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition duration-150 ease-in-out">
            Click here
          </span>
          or drag-and-drop to upload a file
        </slot>
        <p class="mt-1 text-xs text-gray-500">
          <slot name="file-restriction">
            File up to 10MB
          </slot>
        </p>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'FilePicker',
  props: {
    id: {
      type: String,
      required: true,
      default: 'filePicker'
    },
    accept: {
      type: String,
      default: '*/*'
    },
    allowMultiple: {
        type: Boolean,
        default: false
    }
  },
  data: function () {
    return {
        isActive: false
    }
  },
  computed: {
    requiresTypeCheck: function () {
      return this.accept !== '*/*'
    },
    acceptedTypes: function () {
      return this.accept.split(',')
    }
  },
  methods: {
    cancelHandlers (e) {
        e.preventDefault()
        e.stopPropagation()
    },
    setActive (e) {
        this.isActive = true
        this.cancelHandlers(e)
    },
    cancelActive (e) {
        this.isActive = false
        this.cancelHandlers(e)
    },
    fileAdded (e) {
        this.isActive = false
        this.cancelHandlers(e)
        const wasDropped = e.dataTransfer
        const files = wasDropped ? e.dataTransfer.files : e.target.files
        if (wasDropped && !this.allowMultiple && files.length > 1) throw new Error('vue-file-picker: Multiple Files are not allowed')
        if (wasDropped && this.requiresTypeCheck) {
          for (var i = 0; i < files.length; i++) {
            if (this.acceptedTypes.indexOf(files[i].type) === -1) throw new Error('vue-file-picker: File type not allowed')
          }
        }
        this.$emit('vfp-file-added', files)
    }
  }
}
</script>
